import React from 'react'
import Navbar from '../inc/Navbar'

import "./Home.css";

import mission from "../images/Mission.jpg";
import vision from "../images/vision.jpg";
import Slider from '../inc/Slider';
import Ppage from './Ppage';
import HelpLineSlider from './HelpLineSlider';
import ScrollToTop from "react-scroll-to-top";
import babywithmom from "../images/young-mom-holding.jpg";


function Home() {
  return (
    <div>
      <Navbar />

      <br />
      <br />
      <br />
      <br />
      
      <Slider/>
      <br />
      <br />
       <ScrollToTop smooth top="100" color="#081750"/>
      <div className="album py-0">
        <div className="container">
          <div className="row">
            <div className="col-md-6 mt-3">
              <div className="card-body">
                <div className='welcometext'>
                  <h1 style={{color:"#021b66"}} className="card-title"><b>About Us</b></h1>
                </div>
                <p>With a strong portfolio of syrups, capsules, drops, and tablets, we craft safe and effective solutions for all age groups. Rooted in innovation and ethics, our mission is simple—to care, to cure, and to improve everyday lives.</p>

                <div className="d-flex justify-content-start align-items mb-2">
                  <div className="card me-2">
                    <img src={mission} className="card-img-top" alt="mission" />
                    <div className="card-body">
                      <div className='weoffer'>
                        <h5 className="card-title">Our Mission</h5>
                      </div>
                      <p className=" card-text">To enhance lives by developing and delivering high-quality, affordable pharmaceutical and healthcare products through innovation, integrity, and excellence.</p>

                    </div>
                  </div>
                  <div className="card">
                    <img src={vision} className="card-img-top" alt="vision"/>
                    <div className="card-body">
                      <div className='weoffer'>
                        <h5 className="card-title">Our Vision</h5>
                      </div>
                      <p className=" card-text">To be recognized as a leading biotech and pharmaceutical company in India, known for quality, trust, and a commitment to improving healthcare standards globally.</p>

                    </div>
                  </div>
                </div>




              </div>

            </div>

            <div className="col-md-6 mt-3">
              <div className='aboutus'>
                <div className="card-body">
                  <div className='welcometext'>
                    <h1 style={{color:"#021b66"}} className="card-title mb-3"><b>ARISTACURE BIOTECH PRIVATE LIMITED</b></h1>
                  </div>

                  <p className='syrup mb-2'>Aristacure Biotech Pvt. Ltd. is a fast-growing pharmaceutical and nutraceutical company committed to delivering high-quality, affordable healthcare solutions. With a focus on innovation, safety, and patient wellness, we offer a diverse range of products including syrups, capsules, drops, and tablets—designed for all age groups. Driven by science and guided by ethics, Aristacure is dedicated to improving lives through trusted and effective formulations.</p>

                  <div className="d-flex justify-content-end align-items-end mb-0">
                    <a href='about'>
                      <button className='aboutusbutton mt-1'>Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                        <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                      </svg></button>
                    </a>
                  </div>

                </div>
              </div>

            </div>
          </div>
        </div>

      </div>
      <hr />
    <Ppage/>
    <br/>
    <HelpLineSlider/>
      <div className="album py-1">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div class="card mb-3" >
                <div className="row g-0">
                  <div className="col-md-5">
                    <div className='hoverimage'>
                      <img src={babywithmom} className="img-fluid rounded-start image1" alt="bestothopaedicdoctorkrishnanagar" />
                      <div className="overlay">New Baby Guide <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" className="bi bi-check-circle-fill" viewBox="0 0 16 16">
                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                      </svg></div>
                    </div>
                  </div>
                  <div className="col-md-7">
                    <div className="card-body">
                      <div className="textcolor">
                        <h4 className="card-title mb-2"><b>NEW BABY GUIDE</b></h4>
                      </div>
                      <p style={{ color: "grey" }} className="card-text mb-2"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-check-lg" viewBox="0 0 16 16">
                        <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                      </svg> Consultant Child Specialist</p>

                      <div className="accordion" id="accordionExample">
                        <div className="accordion-item">
                          <h2 className="accordion-header" id="headingOne">
                            <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                              Food & Lifestyle
                            </button>
                          </h2>
                          <div id="collapseOne" className="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                            <div className="accordion-body">
                             <h4 className='mb-2' style={{color:"#8a043b"}}><b>🍼 Food & Nutrition Guide</b></h4>
                             <h6>0–6 Months</h6>
                             <p className='mb-2'><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-right-fill" viewBox="0 0 16 16">
  <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z"/>
</svg> Only Breastmilk or Formula – No water, honey, or solid food.</p>
<p className='mb-2'><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-right-fill" viewBox="0 0 16 16">
  <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z"/>
</svg> Breastfeed on demand (every 2–3 hours).</p>
<p><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-right-fill" viewBox="0 0 16 16">
  <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z"/>
</svg> If formula feeding, follow strict hygiene and quantity guidelines.

</p>
<br/>
<h6>6–12 Months</h6>
<p className='mb-2'><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-right-fill" viewBox="0 0 16 16">
  <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z"/>
</svg>Introduce Solids slowly: soft mashed vegetables, fruits, rice cereal, dal water.</p>
<p className='mb-2'><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-right-fill" viewBox="0 0 16 16">
  <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z"/>
</svg> Allergenic Foods (eggs, nuts, dairy) can be introduced gradually.</p>
<p><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-right-fill" viewBox="0 0 16 16">
  <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z"/>
</svg> Continue breast/formula milk until 1 year.</p>
                            </div>
                          </div>
                        </div>
                        <div className="accordion-item">
                          <h2 className="accordion-header" id="headingTwo">
                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                              Lifestyle & Routine
                            </button>
                          </h2>
                          <div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                            <div className="accordion-body">
                            <h5>Sleep</h5>
                            <p className='mb-2'><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-right-fill" viewBox="0 0 16 16">
  <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z"/>
</svg> 0–3 months: 14–17 hrs/day (irregular naps)</p>
         <p className='mb-2'><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-right-fill" viewBox="0 0 16 16">
  <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z"/>
</svg> 4–11 months: Develop a bedtime routine</p>
         <p className='mb-2'><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-right-fill" viewBox="0 0 16 16">
  <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z"/>
</svg> 1–2 years: 11–14 hrs/day (with 1 nap)</p>
      <p><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-right-fill" viewBox="0 0 16 16">
  <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z"/>
</svg> Maintain consistent sleep schedule</p>
                            </div>
                          </div>
                        </div>
                        <div className="accordion-item">
                          <h2 className="accordion-header" id="headingThree">
                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                             ❤️ Parenting Tips
                            </button>
                          </h2>
                          <div id="collapseThree" className="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
                            <div className="accordion-body">
                              <p className='mb-2'><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-right-fill" viewBox="0 0 16 16">
  <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z"/>
</svg> Encourage routines but stay flexible</p>
         <p className='mb-2'><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-right-fill" viewBox="0 0 16 16">
  <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z"/>
</svg> Give lots of love, cuddles, and attention</p>
         <p className='mb-2'><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-right-fill" viewBox="0 0 16 16">
  <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z"/>
</svg> Avoid comparison with other babies – each develops uniquely</p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <a href='tel:  8509330871' className="appointbutton mt-3" type="submit">Book an Appointment</a>

                    </div>
                  </div>
                </div>
              </div>


            </div>

         
          </div>
        </div>
      </div>
    
    </div>
  )
}

export default Home